export default __webpack_public_path__ + "locales/el-GR/EmbeddingPanel.json?hash=c6e64b9a4ef9c37e19a71a12636fa860";